import React from "react";

import { MenuItem, TextField } from "@material-ui/core";

import Currency from "./Currency";
import Entity from "./Entity";
import StaticEntity from "./StaticEntity";
import Status from "./Status";
import Tax from "./Tax";
import TaxFile from "./TaxFile";

export default function Select({
  clearable = true,
  disabled,
  items = {},
  label = " ",
  name,
  rows,
  value,
  onChange,
  ...props
}) {
  let options;
  if (Array.isArray(items)) {
    options = items.map((item) => ({
      key: item,
      value: item,
    }));
  } else {
    options = Object.entries(items).map(([key, value]) => ({
      key,
      value,
    }));
  }

  const keys = {};
  options = options.filter(({ key, value }) => {
    if (!value || keys[key]) {
      return false;
    }
    return (keys[key] = true);
  });

  if (clearable) {
    options.unshift({
      key: "",
      value: clearable === true ? "All" : clearable,
    });
  }

  if (
    value === null ||
    value === undefined ||
    !options.find((option) => option.key === value)
  ) {
    value = "";
  }

  return (
    <TextField
      disabled={disabled}
      label={label}
      name={name}
      select
      value={value}
      onChange={onChange}
      {...props}
    >
      {options.map(({ key, value }) => (
        <MenuItem key={key} value={key}>
          {value}
        </MenuItem>
      ))}
    </TextField>
  );
}

Select.Currency = Currency;
Select.Entity = Entity;
Select.Status = Status;
Select.StaticEntity = StaticEntity;
Select.Tax = Tax;
Select.TaxFile = TaxFile;
